import React from 'react'
import PropTypes from 'prop-types'
import { LogicGateSVG } from './LogicGateSymbol.style'

const XORLogicGate = (props) => (
  <LogicGateSVG width={40} height={32} viewBox="0 0 34 26" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="#687585">
        <path
          d="M5.698 13c0 3.932-.883 7.66-2.463 11H1.001a23.661 23.661 0 002.697-11c0-3.964-.974-7.706-2.698-11.002h2.234a25.656 25.656 0 012.464 11.003z"
          className="selection"
        />
        <path
          d="M4.999 0l6.45.002v.002l.225.002A26.34 26.34 0 0134 13.002a26.342 26.342 0 01-22.55 13H5a25.688 25.688 0 002.554-6H0v-2h8.033c.318-1.618.485-3.29.485-5s-.167-3.383-.486-5.001H0v-2h7.554A25.688 25.688 0 004.999 0z"
          className="selection"
        />
      </g>
      <text
        fill="#FFF"
        fontFamily="Arial-BoldMT, Arial"
        fontSize={9}
        fontWeight="bold"
      >
        <tspan x={10.249} y={16}>
          {'XOR'}
        </tspan>
      </text>
    </g>
  </LogicGateSVG>
)

export default XORLogicGate

XORLogicGate.propTypes = {
  selected: PropTypes.bool,
}
